import { atom } from 'recoil'
import { IProductInStore } from './IProduct'

const productsRecoilState = atom<IProductInStore[] | null>({
  key: 'productsRecoilState',
  default: null,
})

export { productsRecoilState }
